
import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>©2025 Arogya AI. All rights reserved.</p>
     
    </footer>
  );
};

export default Footer;
